export default "__VITE_ASSET__39831b64__"